import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonButton, IonCol, IonFooter, IonGrid, IonIcon, IonRow } from '@ionic/vue'
import { gitBranch, tennisball } from 'ionicons/icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    current: {}
  },
  emits: ['set-page'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const setGroups = () => emit('set-page', 'groups')
const setPlayoffs = () => emit('set-page', 'playoffs')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonFooter), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    color: _ctx.current === 'groups' ? 'medium' : 'light',
                    expand: "full",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (setGroups()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "icon-only",
                        icon: _unref(tennisball)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCol), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    color: _ctx.current === 'playoffs' ? 'medium' : 'light',
                    expand: "full",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (setPlayoffs()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "icon-only",
                        icon: _unref(gitBranch)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})